import React, { Component } from "react";
import PedidoDevolucaoMaterialNovo from "../PedidoDevolucaoMaterialNovo";

export default class PedidoMaterialNovo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <PedidoDevolucaoMaterialNovo tipoPedido={0} {...this.props} />;
  }
}
